export const supportApiEndpoints = {
  getConversations: (page: number, limit: number) =>
    `/support/conversations?page=${page}&limit=${limit}`,
  getConversationThread: (userId: string) =>
    `/support/conversations/${userId}`,
  sendMessage: (userId: string) => `/support/conversations/${userId}`,
  getFeedbacks: (page: number, limit: number) =>
    `/feedbacks?page=${page}&limit=${limit}`,
  getAbout: `/about`,
  updateAbout: `/about`,
};
